import React, { useState } from "react";
import "./topnav.scss";

function ProfileImage({
  src,
  name = "",
  email = "",
}: {
  src?: string;
  name?: string;
  email?: string;
}) {
  const [imgError, setImgError] = useState(false);

  const noImageText = () => {
    if (!name?.trim() && !email?.trim()) return "";

    const userName = name
      ? name.split(" ")?.[0][0] +
        (name.split(" ")?.[1]?.[0] ?? name?.split("")?.[1])
      : email?.split("")?.[0] + email?.split("")?.[1];
    return userName.toUpperCase();
  };

  return (
    <div className="image-container">
      {!imgError ? (
        <img
          src={src}
          alt="Profile"
          onError={() => setImgError(true)}
          loading="lazy"
        />
      ) : (
        <span className="fallback-text">{noImageText()}</span>
      )}
    </div>
  );
}

export default ProfileImage;
